import { EmptyState } from '../components/EmptyState';
import { PageHeader } from '../components/PageHeader';
import type { OfficeSection } from '../layouts/office-sections';

/** Stand-in for an office section whose screen isn't built yet: the real header, and what the screen will hold. */
export function SectionPage({ section }: { section: OfficeSection }) {
  return (
    <>
      <PageHeader eyebrow={section.group} title={section.label} description={section.summary} />
      <EmptyState icon={section.icon} title={`${section.label} is on its way`} description="This screen hasn't been built yet. It will cover:">
        <ul className="flex flex-wrap justify-center gap-2">
          {section.covers.map((item) => (
            <li key={item} className="rounded-full border border-line bg-page px-3 py-1 text-xs text-muted">
              {item}
            </li>
          ))}
        </ul>
      </EmptyState>
    </>
  );
}
